import UserService from './../../../../service/user';
import ValidateService from './../../../../service/validate';
import { FORM_FIELD, AbstractPrompt } from './../../core/abstract';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import { connect } from 'react-redux';

class _AdminSendInvitesPrompt extends AbstractPrompt
{
    constructor(parms)
    {
        super(parms, _AdminSendInvitesPrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.getDefaultState = this.getDefaultState.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.onServerResponse = this.onServerResponse.bind(this);
        this.onServerError = this.onServerError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getConfirmUi = this.getConfirmUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
    }

    static getValidators()
    {
        return {
            inviteCount: {
                isValid: ValidateService.numeric
            },
            shareToUserId: {
                isValid: ValidateService.anyValue
            },
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            inviteCount: {
                name: 'Invites Provided*',
                error: 'Specify the number of invites',
                value: '1',
                visible: true,
                valid: true,
                touched: false,
                type: FORM_FIELD.TEXT
            },
            shareToUserId: {
                name: 'Share to User Id',
                error: 'Leave blank for random, specify user id for a single user',
                value: '',
                visible: true,
                valid: true,
                touched: false,
                type: FORM_FIELD.TEXT
            }
        };
    }

    getDefaultState(store)
    {
        const baseState = super.getDefaultState(store);
        const fields = this.getFieldsModel();
        return {
            ...baseState,
            ...fields
        };
    }

    componentDidMount()
    {
        this.setFocus('shareToUserId');
    }

    onServerResponse(response)
    {
        let nextState = this.getBaseStateOnResponse(response);
        nextState = this.clearFields(nextState);
        this.setState(nextState);
    }

    onServerError(error)
    {
        const nextState = this.getBaseStateOnError(error);
        this.setState(nextState);
    }

    onSendToServer()
    {
        UserService.issueInvites({
            request: this.getServerRequest(),
            onResponse: this.onServerResponse,
            onError: this.onServerError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getServerRequest()
    {
        return {
            inviteCount: this.state.inviteCount.value,
            shareToUserId: this.state.shareToUserId.value
        };
    }

    getConfirmUi(confirmMesssage = 'Invites Issued')
    {
        return super.getConfirmUi(confirmMesssage);
    }

    getSubmitButtonUi(buttonText = 'Issue')
    {
        return super.getSubmitButtonUi(buttonText);
    }
}

const AdminSendInvitesPrompt = connect(mapStateToProps, mapDispatchToProps)(_AdminSendInvitesPrompt);
export default AdminSendInvitesPrompt;
